import { jsx as o, jsxs as y } from "react/jsx-runtime";
import { useContext as D, useId as G, useState as F, createContext as V } from "react";
function Z(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var b = { exports: {} }, x;
function J() {
  return x || (x = 1, (function(t) {
    (function() {
      var n = {}.hasOwnProperty;
      function p() {
        for (var r = "", e = 0; e < arguments.length; e++) {
          var a = arguments[e];
          a && (r = i(r, u(a)));
        }
        return r;
      }
      function u(r) {
        if (typeof r == "string" || typeof r == "number")
          return r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return p.apply(null, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var e = "";
        for (var a in r)
          n.call(r, a) && r[a] && (e = i(e, a));
        return e;
      }
      function i(r, e) {
        return e ? r ? r + " " + e : r + e : r;
      }
      t.exports ? (p.default = p, t.exports = p) : window.classNames = p;
    })();
  })(b)), b.exports;
}
var K = J();
const Q = /* @__PURE__ */ Z(K), h = {
  "purpur-heading": "_purpur-heading_vo751_1",
  "purpur-heading--hyphens": "_purpur-heading--hyphens_vo751_8",
  "purpur-heading--negative": "_purpur-heading--negative_vo751_11",
  "purpur-heading--subsection-100": "_purpur-heading--subsection-100_vo751_14",
  "purpur-heading--title-100": "_purpur-heading--title-100_vo751_20",
  "purpur-heading--title-200": "_purpur-heading--title-200_vo751_26",
  "purpur-heading--title-300": "_purpur-heading--title-300_vo751_32",
  "purpur-heading--title-400": "_purpur-heading--title-400_vo751_38",
  "purpur-heading--title-500": "_purpur-heading--title-500_vo751_44",
  "purpur-heading--title-600": "_purpur-heading--title-600_vo751_50",
  "purpur-heading--title-700": "_purpur-heading--title-700_vo751_56",
  "purpur-heading--display-5": "_purpur-heading--display-5_vo751_62",
  "purpur-heading--display-10": "_purpur-heading--display-10_vo751_68",
  "purpur-heading--display-15": "_purpur-heading--display-15_vo751_74",
  "purpur-heading--display-20": "_purpur-heading--display-20_vo751_80",
  "purpur-heading--display-25": "_purpur-heading--display-25_vo751_86",
  "purpur-heading--display-50": "_purpur-heading--display-50_vo751_92",
  "purpur-heading--display-100": "_purpur-heading--display-100_vo751_98",
  "purpur-heading--display-200": "_purpur-heading--display-200_vo751_104"
}, U = {
  TITLE100: "title-100"
}, v = "purpur-heading", $ = ({
  children: t,
  className: n = "",
  enableHyphenation: p = !1,
  negative: u = !1,
  tag: i,
  variant: r = U.TITLE100,
  ...e
}) => {
  const a = i, l = Q([
    n,
    h[v],
    h[`${v}--${r}`],
    {
      [h[`${v}--hyphens`]]: p,
      [h[`${v}--negative`]]: u
    }
  ]);
  return /* @__PURE__ */ o(a, { className: l, ...e, children: t });
};
$.displayName = "Heading";
function W(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var m = { exports: {} };
var w;
function X() {
  return w || (w = 1, (function(t) {
    (function() {
      var n = {}.hasOwnProperty;
      function p() {
        for (var r = "", e = 0; e < arguments.length; e++) {
          var a = arguments[e];
          a && (r = i(r, u.call(this, a)));
        }
        return r;
      }
      function u(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return p.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var e = "";
        for (var a in r)
          n.call(r, a) && r[a] && (e = i(e, this && this[a] || a));
        return e;
      }
      function i(r, e) {
        return e ? r ? r + " " + e : r + e : r;
      }
      t.exports ? (p.default = p, t.exports = p) : window.classNames = p;
    })();
  })(m)), m.exports;
}
var Y = X();
const P = /* @__PURE__ */ W(Y), k = {
  "purpur-accordion": "_purpur-accordion_mwmy0_1",
  "purpur-accordion__title": "_purpur-accordion__title_mwmy0_4",
  "purpur-accordion--negative": "_purpur-accordion--negative_mwmy0_13"
};
function rr(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var N = { exports: {} }, S;
function er() {
  return S || (S = 1, (function(t) {
    (function() {
      var n = {}.hasOwnProperty;
      function p() {
        for (var r = "", e = 0; e < arguments.length; e++) {
          var a = arguments[e];
          a && (r = i(r, u.call(this, a)));
        }
        return r;
      }
      function u(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return p.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var e = "";
        for (var a in r)
          n.call(r, a) && r[a] && (e = i(e, this && this[a] || a));
        return e;
      }
      function i(r, e) {
        return e ? r ? r + " " + e : r + e : r;
      }
      t.exports ? (p.default = p, t.exports = p) : window.classNames = p;
    })();
  })(N)), N.exports;
}
var tr = er();
const ar = /* @__PURE__ */ rr(tr), pr = {
  "purpur-icon": "_purpur-icon_8u1lq_1",
  "purpur-icon--xxs": "_purpur-icon--xxs_8u1lq_4",
  "purpur-icon--xs": "_purpur-icon--xs_8u1lq_8",
  "purpur-icon--sm": "_purpur-icon--sm_8u1lq_12",
  "purpur-icon--md": "_purpur-icon--md_8u1lq_16",
  "purpur-icon--lg": "_purpur-icon--lg_8u1lq_20",
  "purpur-icon--xl": "_purpur-icon--xl_8u1lq_24"
}, nr = ar.bind(pr), j = "purpur-icon", ir = "md", ur = (t) => t.filter((n) => Object.keys(n).length >= 1).map((n) => `${n.name}="${n.value}"`).join(" "), or = ({ content: t = "", title: n } = {}) => {
  const p = [
    { name: "xmlns", value: "http://www.w3.org/2000/svg" },
    { name: "fill", value: "currentColor" },
    { name: "viewBox", value: "0 0 24 24" },
    n ? { name: "role", value: "img" } : { name: "aria-hidden", value: "true" }
  ], u = n ? `<title>${n}</title>` : "";
  return `<svg ${ur(p)}>${u}${t}</svg>`;
}, _r = (t) => t.replace(/<(\/?)svg([^>]*)>/g, "").trim(), T = ({ svg: t, allyTitle: n, className: p, size: u = ir, ...i }) => {
  const r = or({
    content: _r(t.svg),
    title: n
  }), e = nr(j, `${j}--${u}`, p);
  return /* @__PURE__ */ o("span", { className: e, dangerouslySetInnerHTML: { __html: r }, ...i });
};
T.displayName = "Icon";
const lr = {
  name: "chevron-down",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M20.136 7.864a.9.9 0 0 0-1.272 0L12 14.727 5.136 7.864a.9.9 0 0 0-1.272 1.272l7.5 7.5a.9.9 0 0 0 1.272 0l7.5-7.5a.9.9 0 0 0 0-1.272Z" clip-rule="evenodd"/></svg>',
  keywords: ["chevron-down"],
  category: "utility"
}, q = (t) => /* @__PURE__ */ o(T, { ...t, svg: lr });
q.displayName = "IconChevronDown";
function sr(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var A = { exports: {} }, z;
function cr() {
  return z || (z = 1, (function(t) {
    (function() {
      var n = {}.hasOwnProperty;
      function p() {
        for (var r = "", e = 0; e < arguments.length; e++) {
          var a = arguments[e];
          a && (r = i(r, u.call(this, a)));
        }
        return r;
      }
      function u(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return p.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var e = "";
        for (var a in r)
          n.call(r, a) && r[a] && (e = i(e, this && this[a] || a));
        return e;
      }
      function i(r, e) {
        return e ? r ? r + " " + e : r + e : r;
      }
      t.exports ? (p.default = p, t.exports = p) : window.classNames = p;
    })();
  })(A)), A.exports;
}
var dr = cr();
const gr = /* @__PURE__ */ sr(dr), hr = {
  "purpur-paragraph": "_purpur-paragraph_1vz75_1",
  "purpur-paragraph--disabled": "_purpur-paragraph--disabled_1vz75_7",
  "purpur-paragraph--hyphens": "_purpur-paragraph--hyphens_1vz75_10",
  "purpur-paragraph--negative": "_purpur-paragraph--negative_1vz75_13",
  "purpur-paragraph--paragraph-100": "_purpur-paragraph--paragraph-100_1vz75_16",
  "purpur-paragraph--paragraph-100-medium": "_purpur-paragraph--paragraph-100-medium_1vz75_22",
  "purpur-paragraph--paragraph-100-bold": "_purpur-paragraph--paragraph-100-bold_1vz75_29",
  "purpur-paragraph--paragraph-200": "_purpur-paragraph--paragraph-200_1vz75_36",
  "purpur-paragraph--preamble-100": "_purpur-paragraph--preamble-100_1vz75_42",
  "purpur-paragraph--preamble-200": "_purpur-paragraph--preamble-200_1vz75_48",
  "purpur-paragraph--additional-100": "_purpur-paragraph--additional-100_1vz75_54",
  "purpur-paragraph--additional-100-medium": "_purpur-paragraph--additional-100-medium_1vz75_60",
  "purpur-paragraph--additional-100-bold": "_purpur-paragraph--additional-100-bold_1vz75_67",
  "purpur-paragraph--overline-100": "_purpur-paragraph--overline-100_1vz75_74",
  "purpur-paragraph--overline-200": "_purpur-paragraph--overline-200_1vz75_82"
}, vr = gr.bind(hr), mr = {
  PARAGRAPH100: "paragraph-100"
}, d = "purpur-paragraph", I = ({
  children: t,
  className: n,
  disabled: p,
  enableHyphenation: u = !1,
  negative: i = !1,
  variant: r = mr.PARAGRAPH100,
  ...e
}) => {
  const a = vr(n, d, `${d}--${r}`, {
    [`${d}--hyphens`]: u,
    [`${d}--disabled`]: p,
    [`${d}--negative`]: i
  });
  return /* @__PURE__ */ o("p", { ...e, className: a, children: t });
};
I.displayName = "Paragraph";
const fr = {
  "purpur-accordion-item": "_purpur-accordion-item_1du2l_1",
  "purpur-accordion-item__trigger": "_purpur-accordion-item__trigger_1du2l_4",
  "purpur-accordion-item__header": "_purpur-accordion-item__header_1du2l_10",
  "purpur-accordion-item__trigger__icon": "_purpur-accordion-item__trigger__icon_1du2l_43",
  "purpur-accordion-item__title": "_purpur-accordion-item__title_1du2l_49",
  "purpur-accordion-item__icon": "_purpur-accordion-item__icon_1du2l_50",
  "purpur-accordion-item__rotate": "_purpur-accordion-item__rotate_1du2l_64",
  "purpur-accordion-item__content": "_purpur-accordion-item__content_1du2l_67",
  "purpur-accordion-item__contentText": "_purpur-accordion-item__contentText_1du2l_82",
  "purpur-accordion-item__contentText--limit-width": "_purpur-accordion-item__contentText--limit-width_1du2l_85",
  "purpur-accordion-item--negative": "_purpur-accordion-item--negative_1du2l_107"
}, c = P.bind(fr), _ = "purpur-accordion-item", yr = ({
  children: t,
  className: n,
  fullWidth: p = !1,
  title: u,
  titleTag: i = "h3",
  initialOpen: r = !1,
  onClick: e,
  onOpen: a,
  onClose: l,
  ...M
}) => {
  const L = D(H), g = G(), [s, R] = F(!r), B = c([
    _,
    {
      [`${_}--negative`]: L
    },
    n
  ]);
  return /* @__PURE__ */ y("div", { className: B, ...M, children: [
    /* @__PURE__ */ o(
      $,
      {
        tag: i,
        variant: "title-100",
        className: c([`${_}__header`, `${_}__title`]),
        children: /* @__PURE__ */ y(
          "button",
          {
            type: "button",
            "data-state": s ? "open" : "close",
            onClick: (E) => {
              e && e(E), s ? a && a() : l && l(), R(!s);
            },
            className: c(`${_}__trigger`, n, {
              [`${_}__rotate`]: !s
            }),
            "aria-expanded": !s,
            "aria-controls": g,
            id: g + "button",
            children: [
              u,
              /* @__PURE__ */ o(q, { size: "md", className: c(`${_}__icon`), "aria-hidden": !0 })
            ]
          }
        )
      }
    ),
    /* @__PURE__ */ o(
      "div",
      {
        className: c(`${_}__content`, n),
        "aria-hidden": s,
        id: g,
        "aria-labelledby": g + "button",
        role: "region",
        children: /* @__PURE__ */ o(
          "div",
          {
            className: c(`${_}__contentText`, {
              [`${_}__contentText--limit-width`]: !p
            }),
            children: typeof t == "string" ? /* @__PURE__ */ o(I, { variant: "paragraph-200", children: t }) : t
          }
        )
      }
    )
  ] });
}, O = P.bind(k), f = "purpur-accordion", H = V(!1), C = ({
  children: t,
  className: n,
  negative: p = !1,
  title: u,
  titleTag: i = "h2",
  titleVariant: r = "title-300",
  schema: e,
  ...a
}) => {
  const l = O([
    f,
    {
      [`${f}--negative`]: p
    },
    n
  ]);
  return /* @__PURE__ */ y("div", { className: l, ...a, children: [
    u && /* @__PURE__ */ o($, { tag: i, variant: r, className: O(`${f}__title`), children: u }),
    /* @__PURE__ */ o(H.Provider, { value: p, children: t }),
    e && /* @__PURE__ */ o(
      "script",
      {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
          __html: e
        }
      }
    )
  ] });
};
C.Item = yr;
C.displayName = "Accordion";
export {
  C as Accordion,
  H as NegativeContext
};
//# sourceMappingURL=accordion.es.js.map
